// extracted by mini-css-extract-plugin
export default {"container":"zaa-z","productName":"Aaa-z","price":"Baa-z","dimensions":"Caa-z"};